<template>
  <div style="display: flex; flex-direction: column" class="client">
    <div class="query-bar">
      <span style="font-size:10px;">不显示禁用</span>
      <el-checkbox v-model="query.prohibit" size="small" style="margin-right: 20px;" @change="refresh" />
      <el-input
        v-model="query.name"
        placeholder="名称"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-button type="primary" size="small" @click="refresh">查询</el-button>
      <el-button
        type="primary"
        size="small"
        @click="_modify(null)"
      >添加</el-button>
      <el-button-export
        :url="downloadUrl"
        type="primary"
        size="small"
        style="margin: 0 10px"
      >导出</el-button-export>

      <el-button type="warning" size="small" @click="_import">导入</el-button>
      <input
        ref="fileSel"
        type="file"
        style="display: none"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      >
      <el-button-export
        :url="downloadTeamplateUrl"
        type="success"
        size="small"
        style="margin: 0 10px"
      >导入模板下载</el-button-export>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table v-loading="loading" :data="tableData" height="100%">
        <el-table-column prop="fName" label="客户名称" />
        <el-table-column prop="fBillingName" label="开票名称" />
        <el-table-column prop="fName_sh" label="收货人" width="80" />
        <el-table-column prop="fPhone" label="联系电话" />
        <el-table-column prop="fRegion" label="区域" width="60" />
        <el-table-column prop="fAddress_sh" label="收货地址" />
        <el-table-column prop="fDes" label="简介" width="100" />
        <el-table-column label="操作" class-name="table-oper-col" width="130">
          <template slot-scope="scope">
            <template>
              <el-button
                type="text"
                size="small"
                @click="_modify(scope.row)"
              >查看</el-button>
            </template>
            <template>
              <ConfirmButton @confirm="_delete(scope.row)">删除</ConfirmButton>
            </template>
            <template v-if="!scope.row.fProhibit">
              <ConfirmButton @confirm="_prohibit(scope.row)">禁用</ConfirmButton>
            </template>
            <template v-if="scope.row.fProhibit">
              <ConfirmButton @confirm="_unProhibit(scope.row)">反禁用</ConfirmButton>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import EditForm from './EditForm'
import { Today } from '@assets/site'
// import readForm from './readForm'
import ConfirmButton from '@components/ConfirmButton'
import FileDownload from './FileDownload'

export default {
  components: {
    EditForm,
    ConfirmButton,
    FileDownload
  },
  data() {
    return {
      query: {
        name: null,
        prohibit: true,
        pageIndex: 1,
        pageSize: 20
      },
      pageRecordTotal: 0,
      tableData: [],
      loading: false,
      fileList: [],
      optionArr: [
        {
          label: '未提交',
          value: '未提交'
        },
        {
          label: '已提交',
          value: '已提交'
        },
        {
          label: '审核中',
          value: '审核中'
        },
        {
          label: '已审核',
          value: '已审核'
        }
      ],
      currentEditItem: null
    }
  },
  mounted() {
    this.refresh()
  },
  methods: {
    // 获取快递公司列表
    refresh() {
      this.loading = true
      this.$httpPost('BusinessManage/Customer/CustomerEntry', this.query)
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }
          this.tableData = res.datalist.dataEntry
          this.pageRecordTotal = res.datalist.total
        })
        .finally(() => (this.loading = false))
    },

    // 新增经销商
    _modify: async function(row) {
      // console.log(row, 'row')
      const isNew = !row
      if (isNew) {
        this.currentEditItem = {
          fCustomerID: null,
          fNumber: null,
          fBillingName: null,
          fName_sh: null,
          fPhone: null,
          fRegionID: null,
          fRegion: null,
          fAddress_sh: null,
          fBusinessNo: null,
          fAddress_jy: null,
          fDes: null
        }
      } else {
        this.currentEditItem = Object.assign({}, row)
      }
      const h = this.$createElement
      this.$formDlg({
        title: isNew ? `新增客户` : '查看客户',
        formTpl: <EditForm form={this.currentEditItem}></EditForm>,
        formSubmit: (formData) => this.postData(isNew ? 0 : 1, formData),
        width: '85%'
      })
    },
    _delete(row) {
      this.postData(2, row)
    },
    _prohibit(row) {
      this.postData(3, row)
    },
    _unProhibit(row) {
      this.postData(4, row)
    },
    postData(modifyType, data) {
      return this.$httpPost(`BusinessManage/Customer/CustomerModify`, {
        datalist: JSON.stringify({ modifyType: modifyType, info: data })
      }).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    },
    downloadUrl: function() {
      return this.$buildDownloadUrl(
        'Download/CustomerDownload',
        this.queryParam(true)
      )
    },
    downloadTeamplateUrl: function() {
      return this.$buildDownloadUrl(
        'Download/DownloadTemplate',
        { fileName: '客户模板.xlsx' }
      )
    },
    queryParam: function(forExport) {
      var rtn = {
        ...this.query
      }
      if (forExport) {
        delete rtn.pageIndex
        delete rtn.pageSize
      }
      return rtn
    },
    // 上传文件

    _import: function() {
      var fileSel = this.$refs.fileSel
      fileSel.onchange = () => {
        setTimeout(() => {
          fileSel.value = null
        }, 100)
        if (!fileSel.files.length) return
        var file = fileSel.files[0]
        this.$httpPostFile('Upload/CustomerUpload', file).then((res) => {
          if (!res.isSuccess) {
            if (res.returnCode == '00010') {
              const h = this.$createElement
              this.$formDlg({
                title: res.message,
                readonly: true,
                formTpl: <FileDownload url={res.datalist}></FileDownload>,
                formSubmit: (formData) =>
                  this.postData(isNew ? 1 : 2, formData)
              })
            } else {
              this.$message.error(res.message)
            }
          } else {
            this.$message.success(res.message)
            this.refresh()
          }
        })
      }
      fileSel.click()
    },
    dateFormat: function(row, column, cellValue) {
      var date = cellValue
      if (date == undefined) {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style lang="less">
.client {
}
</style>
